import { ReactNode } from "react";
import ReactModal from "react-modal";

type ModalProps = {
  children: ReactNode;
  className?: string;
  contentLabel?: string;
  isOpen: boolean;
  shouldScrollLockApp?: boolean;
  style?: ReactModal.Styles;
  onClose: () => void;
};

const Modal = ({
  children,
  className,
  contentLabel,
  isOpen,
  shouldScrollLockApp = true,
  style,
  onClose,
}: ModalProps) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnEsc
      shouldCloseOnOverlayClick
      className={`absolute left-1/2 top-1/2 z-10000 -translate-x-1/2 -translate-y-1/2 ${className}`}
      style={{
        ...style,
        overlay: {
          zIndex: 9999,
          backgroundColor: "rgba(79,79,79,0.7)",
          ...style?.overlay,
        },
      }}
      appElement={document.getElementById("root")!}
      bodyOpenClassName={shouldScrollLockApp ? "ReactModal__Body--open" : null}
      contentLabel={contentLabel}
    >
      {children}
    </ReactModal>
  );
};

export default Modal;
